/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {connect} from 'react-redux';

import * as APPDATA from '@/constants/pcConstAppData';

import StatusText from './StatusText';

import '../StatusPage.less';

@connect((store) => ({
  currentVolume: store.setupStore.currentVolume,
  currentPressure: store.setupStore.currentPressure,
  estimateConcentration: store.setupStore.estimateConcentration,
  currentBuffer: store.setupStore.currentBuffer,
}))
class StatusSensor extends React.PureComponent {
  render() {
    const {currentVolume, currentPressure, estimateConcentration, currentBuffer} = this.props;
    const statusText = [
      {
        label: APPDATA.FIELD_NAME.CURRENT_PRESSURE,
        value: currentPressure,
        unit: APPDATA.UNIT.psi,
      },
      {
        label: APPDATA.FIELD_NAME.CURRENT_SAMPLE_VOLUME,
        value: currentVolume,
        unit: APPDATA.UNIT.ml,
      },
      {
        label: APPDATA.FIELD_NAME.CURRENT_BUFFER_VOLUME,
        value: currentBuffer,
        unit: APPDATA.UNIT.ml,
      },
      {
        label: APPDATA.FIELD_NAME.ESTIMATED_CURRENT_CONCENTRATION,
        value: estimateConcentration,
        unit: APPDATA.UNIT.mg_per_ml,
      },
    ];
    return (
      <div>
        <StatusText data={statusText} />
      </div>
    );
  }
}
export default StatusSensor;
